import Icon from '@/components/Icon'

import { InfoIcon, InfoText, InfoWrapper } from './Info.styles'

interface InfoProps {
  children: React.ReactNode
  className?: string
}

const Info = ({ children, className }: InfoProps) => {
  return (
    <InfoWrapper className={className}>
      <InfoIcon aria-hidden={true}>
        <Icon name="info" />
      </InfoIcon>
      <InfoText>{children}</InfoText>
    </InfoWrapper>
  )
}

export default Info
